import { Box } from "@mui/material";
import * as React from "react";
import FeaturedInNewsLetterList from "./FeaturedInNewsLetterList";
export default function FeaturedInNewsLetter() {
  return (
    <>
      <Box sx={{ width: "100%" }} className="container container-h-full">
        <Box>
          <div className="content-subheader">
            <h2 className="font-weight-bolder">Featured in Newsletter List</h2>
          </div>
        </Box>
        <div className="sub-content-sec recently-blog">
          <FeaturedInNewsLetterList />
        </div>
      </Box>
    </>
  );
}
